import { Box, Flex, Heading } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import AtracaoCard from "./components/AtracaoCard";
import card3 from "assets/images/BarMolhado.jpg";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import useWindowDimensions from "core/helpers/windowDimensions";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import "./styles.css";

export default function AtracoesCarousel() {
  const { width } = useWindowDimensions();

  const getSliderPercentage = () => {
    if (width > 1024) {
      return 33.333;
    } else if (width > 900) {
      return 50;
    }
    return 100;
  };

  return (
    <Flex flexDir="column" w="100%">
      <Heading
        variant="superCellMagic"
        fontWeight="medium"
        fontSize="24px"
        color={colors.purple500}
      >
        PRINCIPAIS ATRAÇÕES:
      </Heading>

      <Box
        className="carousel-container"
        mt="50px"
        position="relative"
        px={width < 768 ? "30px" : "0"}
      >
        <Carousel
          centerMode
          infiniteLoop={true}
          centerSlidePercentage={getSliderPercentage()}
          showStatus={false}
          showIndicators={false}
          renderArrowPrev={(clickHandle, hasPrev) =>
            hasPrev && (
              <Flex
                onClick={clickHandle}
                rounded="full"
                bg={colors.blue100}
                w="40px"
                h="40px"
                justify="center"
                align="center"
                position="absolute"
                zIndex={10}
                top="50%"
                left={width < 768 ? "-20px" : "10px"}
                transform="translateY(-50%)"
                cursor="pointer"
                _hover={{ bg: colors.blue200 }}
                className="carousel-arrow-prev"
              >
                <MdOutlineArrowBackIos color="white" />
              </Flex>
            )
          }
          renderArrowNext={(clickHandle, hasNext) =>
            hasNext && (
              <Flex
                onClick={clickHandle}
                rounded="full"
                bg={colors.blue100}
                w="40px"
                h="40px"
                justify="center"
                align="center"
                position="absolute"
                top="50%"
                right={width < 768 ? "-20px" : "10px"}
                transform="translateY(-50%)"
                cursor="pointer"
                _hover={{ bg: colors.blue200 }}
                className="carousel-arrow-next"
              >
                <MdOutlineArrowForwardIos color="white" />
              </Flex>
            )
          }
        >
          <AtracaoCard
            bgImage={
              "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/carrossel/04-Toboagua.jpg"
            }
            titleCard="TOBOÁGUAS RADICAIS: FANTÁSTICO, FABULOSO E MAGNÍFICO"
            descriptionCard={
              "O trio de toboáguas radicais do ÁCQUA PARK PANTANAL é feito para os corajosos de verdade! São três escorregadores emocionantes, cada um com curvas, quedas e velocidades diferentes, que garantem aquela dose extra de adrenalina. É subir, respirar fundo e se jogar nessa aventura molhada cheia de emoção. Vai encarar?"
            }
          />
          <AtracaoCard
            bgImage={
              "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/carrossel/07-Acqualandia.jpg"
            }
            titleCard="ACQUALÂNDIA"
            descriptionCard="Esta atração é uma das preferidas da família, pois tem uma profundidade adequada para crianças menores e conta com muitos escorregadores infantis, a ÁCQUA RAMPA e o BALDE MALUCO, que também fazem a alegria de adultos que podem se divertir junto com seus filhos em um ambiente super colorido e divertido."
          />
          <AtracaoCard
            bgImage={
              "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/carrossel/01-baldaoMaluco.jpg"
            }
            titleCard="BALDÃO MALUCO"
            descriptionCard="O BALDE MALUCO também faz a alegria de adultos e crianças. A brincadeira é simples. Um grande 'balde' armazena a água e, quando cheio, cai dentro de uma piscina, formando uma cascata."
          />
          <AtracaoCard
            bgImage={
              "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/carrossel/08-PiscinaOndas.jpg"
            }
            titleCard="PISCINA DE ONDAS"
            descriptionCard="Uma das maiores piscinas de ondas do Brasil! São 15 tipos de ondas que lembram as ondas do mar. Elas têm intensidades que vão das mais leves até as ondas do tipo tempestade e tsunami que são emocionantes! Os mais ousados costumam ficar no fundo para sentir a adrenalina das ondas mais agitadas. Já aqueles que preferem tranquilidade e relaxamento podem ficar no raso sentados e recebendo as ondas que quebram na borda."
          />
          <AtracaoCard
            bgImage={card3}
            titleCard="BAR MOLHADO"
            descriptionCard="É um riacho formado por 6 piscinas naturais com águas correntes e muito arborizado. Dentro dele tem mesas e cadeiras onde é possível sentar em família para se refrescar na sombra, enquanto toma uma bebida e desfruta daquela comida, lanche ou porção preferida."
          />
          <AtracaoCard
            bgImage={
              "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/carrossel/03-Kamikaze.jpg"
            }
            titleCard="O KAMIKAZE"
            descriptionCard="O Kamikaze de 4 pistas é uma das atrações mais emocionantes do ÁCQUA PARK PANTANAL! São quatro escorregadores lado a lado, onde a adrenalina toma conta do início ao fim. A descida é rápida, com curvas suaves e muita água, garantindo diversão para quem curte velocidade e disputa entre amigos ou família. Ideal para quem gosta de emoção com segurança, o Kamikaze é parada obrigatória para os aventureiros de plantão!"
          />
          <AtracaoCard
            bgImage={
              "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/carrossel/02-HalfPipe.jpg"
            }
            titleCard="O HALF PIPE"
            descriptionCard="O Half Pipe do ÁCQUA PARK PANTANAL é pura emoção — e o melhor: a aventura acontece em dupla! Com boias infláveis para duas pessoas, você compartilha cada momento de adrenalina com um amigo ou familiar. A descida em formato de 'U' faz você deslizar de um lado para o outro como numa rampa de skate, desafiando a gravidade e arrancando gritos e risadas. É a mistura perfeita de diversão, velocidade e parceria!"
          />
        </Carousel>
      </Box>
    </Flex>
  );
}
